export default __webpack_public_path__ + "static/media/sample-grid-isometric.a95296fe.svg";